import { Trans, useTranslation } from 'react-i18next';
import { MyLink } from '@scramble/ui';
import { CONTACT_EMAIL } from '@scramble/utils';
import s from './index.module.scss';

export const ImportantNotes = ({ destination }) => {
  const { t } = useTranslation();

  const showNonSepaNote = destination && !destination.is_sepa

  return (
    <div className={s.wrapper}>
      <div className="f-headline-2xs f-500">
        {t('funds:important_notes.title')}
      </div>
      <div className={s.notes}>
        {showNonSepaNote && (
          <div className="f-body-sm">
            <Trans
              ns="withdraw"
              i18nKey="important_notes.withdrawal_amount"
              components={{
                Span: <span className="f-500" />,
              }}
            />
          </div>
        )}
        <div className="f-body-sm">
          <Trans
            ns="withdraw"
            i18nKey="important_notes.account_currency"
            components={{
              Span: <span className="f-500" />,
            }}
          />
        </div>
        <div className="f-body-sm">
          <Trans
            ns="withdraw"
            i18nKey="important_notes.processing_time"
            components={{
              Span: <span className="f-500" />,
            }}
          />
        </div>
        <div className="f-body-sm">
          <Trans
            ns="withdraw"
            i18nKey="important_notes.support"
            values={{ email: CONTACT_EMAIL }}
            components={{
              Span: <span className="f-500" />,
              Email: <MyLink href={`mailto:${CONTACT_EMAIL}`} underline />,
            }}
          />
        </div>
      </div>
    </div>
  );
};